import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetV2ARecipientSearch = gql`
  query GetV2ARecipientSearch($searchTerm: String!) {
    v2aRecipientSearch(input: { searchTerm: $searchTerm }) {
      __typename
      ... on V2ARecipientSearchSuccess {
        recipient {
          id
          email {
            address
          }
          phoneNumber
          displayName
          __typename
          ... on V2AInternalRecipient {
            name {
              initials
              full
              first
              last
            }
          }
        }
      }
      ... on V2ARecipientSearchError {
        ...error
        __typename
      }
      ... on V2ARecipientSearchThrottled {
        ...error
        expiresAt
        __typename
      }
      ... on V2ARecipientSearchNotFound {
        copy
        __typename
      }
      ... on Error {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default GetV2ARecipientSearch;
